import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { IOption } from 'ng-select';
import { UploadService } from 'app/uploads/shared/upload.service';
import { Upload } from 'app/uploads/shared/upload';
import * as firebase from 'firebase/app';
import { HRMSService } from 'app/hrms/shared/hrms.service';
import { UserService } from 'app/users/shared/user.service';
import { DatePipe } from '@angular/common';
import { UtilService } from 'app/hrms/shared/util.service';
import { LogisticsService } from 'app/logistics-operations/shared/logistics.service';
import { DateService } from 'app/date/date.service';
import { Router } from '@angular/router';
import { NotificationToastService } from 'app/notification/notification-toast.service';

@Component({
  selector: 'app-onboard',
  templateUrl: './onboard.component.html',
  styleUrls: ['./onboard.component.scss'],
  providers: [UploadService, DatePipe]
})
export class OnboardComponent implements OnInit {
  myForm: FormGroup;
  public imageToUpload = "assets/images/avatar-4.png";
  selectedFiles: FileList;
  fileList:any = [];
  noFiles: string = 'No files uploaded.';
  submitted:boolean = false;
  errorMessage:string;
  designationsOptions: Array<IOption> = [];
  @Input("departmentsOptions") departmentsOptions: Array<IOption> = [];
  @Input("branchOptions") branchOptions: Array<IOption> = [];
  dlfError:boolean = false;
  dlbError: boolean = false;
  phone_error:boolean = false;
  netSalary:any;
  driverDesignationKey:any;
  currentemployeeId:any = 1000;
  bsValue = new Date();
  submitButtonDisabled : boolean = false;
  companyassets: Array<IOption> = [
    {label: 'Mobile', value: 'Mobile'},
    {label: 'Laptop', value: 'Laptop'},
    {label: 'Phone', value: 'Phone'},
    {label: 'Car', value: 'Car'}
  ];
  countryOptions: Array<IOption> = [
    {label: 'India', value: 'India'},
    {label: 'China', value: 'China'},
    {label: 'Saudi Arabia', value: 'Saudi Arabia'},
    {label: 'United States', value: 'United States'}
  ];
  applicationRoleOptions: Array<IOption> = [
    {label: 'Super Admin', value: 'super admin'},
    {label: 'Admin', value: 'admin'},
    {label: 'Supervisor', value: 'supervisor'},
    {label: 'Employee', value: 'employee'},
    {label: 'Driver', value: 'driver'}
  ];
  reportingToOptions: Array<IOption> = [
    /* {label: 'Lamrath', value: 'Lamrath'},
    {label: 'Javed', value: 'Javed'} */
  ];
  employmentTypeOptions: Array<IOption> = [
    {label: 'Contract', value: 'Contract'},
    {label: 'Permanent', value: 'Permanent'}
  ];
  @Output() messageEvent = new EventEmitter<string>();
  position:String = 'bottom-right';
  constructor(private uploadService:UploadService, private hrmsService: HRMSService, private  userService:UserService, private dateService: DateService, private util:UtilService, private ls:LogisticsService, private router:Router, private nf:NotificationToastService) { }

  ngOnInit() {
    this.initializeForm();
    this.getAllDesignations();
    this.getEmployeeId();
    this.getReportingTo();
    this.getCompanyAssets();
  }
  public initializeForm()
  {
    var randomstring = Math.random().toString(36).slice(-8);
    this.myForm = new FormGroup({
      photoUrl: new FormControl(''),
      firstName: new FormControl('',Validators.required),
      middleName: new FormControl(''),
      lastName: new FormControl('',Validators.required),
      email: new FormControl('',[Validators.required,Validators.email]),
      dob: new FormControl('',Validators.required),
      /* userName: new FormControl('',Validators.required), */
      password: new FormControl(randomstring,Validators.required),
      country: new FormControl('',Validators.required),
      phoneNumber: new FormControl('',[Validators.required, Validators.minLength(9), Validators.maxLength(10)]),
      address: new FormControl('',Validators.required),
      employeeId: new FormControl('',Validators.required),
      designation: new FormControl('',Validators.required),
      branch: new FormControl('',Validators.required),
      employmentType: new FormControl('',Validators.required),
      companyAssets: new FormControl(''),
      passportNumber: new FormControl(''),
      passportExpiryDate: new FormControl(''),
      joiningDate: new FormControl(this.bsValue,Validators.required),
      visaIssuedDate: new FormControl(''),
      visaExpiryDate: new FormControl(''),
      iqamaIssuedDate: new FormControl(''),
      iqamaExpiryDate: new FormControl(''),
      iqamaNumber: new FormControl('',Validators.required),
      department: new FormControl('',Validators.required),
      role: new FormControl('',Validators.required),
      reportingTo: new FormControl('',Validators.required),
      drivingLicenceFront: new FormControl(''),
      drivingLicenceBack: new FormControl(''),
      passportFront: new FormControl(''),
      passportBack: new FormControl(''),
      visaCopy: new FormControl(''),
      iqama: new FormControl(''),
      basic: new FormControl('',Validators.required),
      da: new FormControl(''),
      hra: new FormControl(''),
      conveyance: new FormControl(''),
      allowance: new FormControl(''),
      medicalAllowance: new FormControl(''),
      others: new FormControl(''),
      pf: new FormControl(''),
      tds: new FormControl(''),
      tax: new FormControl('')
    });
  }
  getEmployeeId()
  {
    this.userService.getLastEmployeeId().on("value",data=>{
      var user = data.val();
      if(user!=null)
      {
        for(let i in user)
        {
          console.log("employeeId",user[i].employeeId);
          this.currentemployeeId = user[i].employeeId + 1;
          this.myForm.get('employeeId').setValue(this.currentemployeeId);
        }
      }
      else
      {
        this.currentemployeeId = 1000;
      }
    });
  }
  public detectFiles(event,type) {
    this.selectedFiles = event.target.files;
    console.log("this.selectedFiles",this.selectedFiles);
    console.log("file name",event.target.files[0].name);
    var name = event.target.files[0].name;
    this.readUrl(event,type,name);
    }

    public readUrl(fileEvent:any,type:string,name:string) {
    if (fileEvent.target.files && fileEvent.target.files[0]) {
      var reader = new FileReader();
      reader.onload = (event:any) => {
        switch(type)
        {
          case 'photo':
          this.imageToUpload = event.target.result;
          this.fileList[0]= {name: name, file:fileEvent.target.files, img:event.target.result};
          break;
          case 'dlf':
          this.fileList[1]= {name: name, file:fileEvent.target.files, img:event.target.result};
          break;
          case 'dlb':
          this.fileList[2]= {name: name, file:fileEvent.target.files, img:event.target.result};
          break;
          case 'pf':
          this.fileList[3]= {name: name, file:fileEvent.target.files, img:event.target.result};
          break;
          case 'pb':
          this.fileList[4]= {name: name, file:fileEvent.target.files, img:event.target.result};
          break;
          case 'vc':
          this.fileList[5]= {name: name, file:fileEvent.target.files, img:event.target.result};
          break;
          case 'iq':
          this.fileList[6]= {name: name, file:fileEvent.target.files, img:event.target.result};
          break;
        }
      } 
      reader.readAsDataURL(fileEvent.target.files[0]);
    }
  }

  public func(type)
  {
    switch(type)
        {
          case 'photo':
          this.imageToUpload = "assets/images/avatar-4.png";
          this.fileList[0]= null;
          break;
          case 'dlf':
          this.fileList[1]= null;
          break;
          case 'dlb':
          this.fileList[2]= null;
          break;
          case 'pf':
          this.fileList[3]= null;
          break;
          case 'pb':
          this.fileList[4]= null;
          break;
          case 'vc':
          this.fileList[5]= null;
          break;
          case 'iq':
          this.fileList[6]= null;
          break;
        }
  }

  public onSubmit():void{
    this.submitButtonDisabled = true;
    this.onChangeCountry(this.getCountryCode());
    console.log("code",this.getCountryCode());
    this.submitted = true;
    this.dlfError =false;
    this.dlbError =false;
    console.log("form data", this.myForm.value);
    //this.uploadDocuments("gh");
    this.calculateSalary(this.myForm.value);
    if(this.myForm.value.role === 'driver' || this.myForm.value.designation === this.driverDesignationKey)
    {
      if(this.myForm.value.drivingLicenceFront == '')
      {
        this.submitButtonDisabled = false;
        this.dlfError =true;
      }
      else if(this.myForm.value.drivingLicenceBack == '')
      {
        this.submitButtonDisabled = false;
        this.dlbError =true;
      }
      else if(this.myForm.value.drivingLicenceFront != '' && this.myForm.value.drivingLicenceBack != '' && this.myForm.valid)
      {
        this.dlfError =false;
        this.dlbError =false;
        this.submitButtonDisabled = true;
        //this.checkUserExisting();
        this.checkPhoneNumberExisting();
      }
    }
    else if(this.myForm.valid)
    {
      console.log("checkUserExisting");
      this.submitButtonDisabled = true;
      //this.checkUserExisting();
      this.checkPhoneNumberExisting();
    }
    else
    {
      this.submitButtonDisabled = false;
    }
  }
  private checkUserExisting():void{
    /* var userExistsTask = this.userService.checkUserExists(this.myForm.value.userName);
    userExistsTask.snapshotChanges().subscribe(item=>{
      console.log("item",item);
      if(item.length>0)
          {
            alert("user name exists");
          }
          else
          {
           this.checkPhoneNumberExisting();
          }
      }); */
      this.userService.checkUserExistsInDb(this.myForm.value.userName).once("value",(snapshot)=>{
        if(snapshot.numChildren() > 0)
          {
            alert("user name exists");
            this.submitButtonDisabled = false;
          }
          else
          {
           this.checkPhoneNumberExisting();
          }
      });
  }

  private checkPhoneNumberExisting():void{
    var PhoneNumberExistsTask = this.userService.checkPhoneNumberExists(this.myForm.value.phoneNumber);
    PhoneNumberExistsTask.once("value",(snapshot)=>{
      if(snapshot.numChildren() > 0)
      {
        alert("phone number exists");
        this.submitButtonDisabled = false;
      }
      else
      {
        this.createUser();
      }
    });
  }
  private createUser():void{
    this.userService.createUser(this.myForm.value.email,this.myForm.value.password).then((success)=>
    {
      //store user details
      console.log("success",success);
      this.uploadDocuments(this.userService.getCurrentUser());
    }
    ).catch((error)=>{
      //error message
      this.errorMessage = error;
      alert(error.message);
      this.submitButtonDisabled = false;
    });
  }
  private uploadDocuments(uid:string)
  {
    /* for(var i=0;i<6;i++)
    {
      this.uploadFile(uid,i);
    } */
    if(this.myForm.value.photoUrl != '')
    {
      this.uploadFileProfile(uid);
    }
    else if(this.myForm.value.role === 'driver' || this.myForm.value.designation === this.driverDesignationKey)
    {
      this.uploadFileDLF(uid);
    }
    else if(this.myForm.value.passportFront != '')
    {
      this.uploadFilePF(uid);
    }
    else if(this.myForm.value.passportBack != '')
    {
      this.uploadFilePB(uid);
    }
    else if(this.myForm.value.visaCopy != '')
    {
      this.uploadFileVC(uid);
    }
    else if(this.myForm.value.iqama != '')
    {
      this.uploadFileIqama(uid);
    }
    else
    {
      this.constructData(uid);
    }
    
  }
  uploadFileProfile(uid:string):void{
    let file = this.fileList[0].file.item(0);
    //var fileName = this.fileName(i);
    console.log("file",file.name);
    var currentUpload = new Upload(file);
    var uploadTask=this.uploadService.uploadFile(currentUpload,uid,file.name);
    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
      (snapshot) =>  {
        // upload in progress
        currentUpload.progress = (uploadTask.snapshot.bytesTransferred / uploadTask.snapshot.totalBytes) * 100;
        this.fileList[0].upload = currentUpload;
      },
      (error) => {
        // upload failed
        console.log(error);
      },
      () => {
        // upload success
        currentUpload.url = uploadTask.snapshot.downloadURL;
        currentUpload.name = currentUpload.file.name;
        this.fileList[0].upload = currentUpload;
        console.log("uploaded "+currentUpload.url);
        if(this.myForm.value.role === 'driver' || this.myForm.value.designation === this.driverDesignationKey)
        {
          this.uploadFileDLF(uid);
        }
        else if(this.myForm.value.passportFront != '')
        {
          this.uploadFilePF(uid);
        }
        else if(this.myForm.value.passportBack != '')
        {
          this.uploadFilePB(uid);
        }
        else if(this.myForm.value.visaCopy != '')
        {
          this.uploadFileVC(uid);
        }
        else if(this.myForm.value.iqama != '')
        {
        this.uploadFileIqama(uid);
        }
        else
        {
          this.constructData(uid);
        }
      }
    );
  }
  uploadFileDLF(uid:string):void{
    let file = this.fileList[1].file.item(0);
    console.log("file",file.name);
    var currentUpload = new Upload(file);
    var uploadTask=this.uploadService.uploadFile(currentUpload,uid,file.name);
    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
      (snapshot) =>  {
        // upload in progress
        currentUpload.progress = (uploadTask.snapshot.bytesTransferred / uploadTask.snapshot.totalBytes) * 100;
        this.fileList[1].upload = currentUpload;
      },
      (error) => {
        // upload failed
        console.log(error);
      },
      () => {
        // upload success
        currentUpload.url = uploadTask.snapshot.downloadURL;
        currentUpload.name = currentUpload.file.name;
        this.fileList[1].upload = currentUpload;
        console.log("uploaded "+currentUpload.url);
        this.uploadFileDLB(uid);
      }
    );
  }
  uploadFileDLB(uid:string):void{
    let file = this.fileList[2].file.item(0);
    console.log("file",file.name);
    var currentUpload = new Upload(file);
    var uploadTask=this.uploadService.uploadFile(currentUpload,uid,file.name);
    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
      (snapshot) =>  {
        // upload in progress
        currentUpload.progress = (uploadTask.snapshot.bytesTransferred / uploadTask.snapshot.totalBytes) * 100;
        this.fileList[2].upload = currentUpload;
      },
      (error) => {
        // upload failed
        console.log(error);
      },
      () => {
        // upload success
        currentUpload.url = uploadTask.snapshot.downloadURL;
        currentUpload.name = currentUpload.file.name;
        this.fileList[2].upload = currentUpload;
        console.log("uploaded "+currentUpload.url);
        if(this.myForm.value.passportFront != '')
        {
          this.uploadFilePF(uid);
        }
        else if(this.myForm.value.passportBack != '')
        {
          this.uploadFilePB(uid);
        }
        else if(this.myForm.value.visaCopy != '')
        {
        this.uploadFileVC(uid);
        }
        else if(this.myForm.value.iqama != '')
        {
        this.uploadFileIqama(uid);
        }
        else
        {
          this.constructData(uid);
        }
      }
    );
  }
  uploadFilePF(uid:string):void{
    let file = this.fileList[3].file.item(0);
    console.log("file",file.name);
    var currentUpload = new Upload(file);
    var uploadTask=this.uploadService.uploadFile(currentUpload,uid,file.name);
    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
      (snapshot) =>  {
        // upload in progress
        currentUpload.progress = (uploadTask.snapshot.bytesTransferred / uploadTask.snapshot.totalBytes) * 100;
        this.fileList[3].upload = currentUpload;
      },
      (error) => {
        // upload failed
        console.log(error);
      },
      () => {
        // upload success
        currentUpload.url = uploadTask.snapshot.downloadURL;
        currentUpload.name = currentUpload.file.name;
        this.fileList[3].upload = currentUpload;
        console.log("uploaded "+currentUpload.url);
        if(this.myForm.value.passportBack != '')
        {
          this.uploadFilePB(uid);
        }
        else if(this.myForm.value.visaCopy != '')
        {
        this.uploadFileVC(uid);
        }
        else if(this.myForm.value.iqama != '')
        {
        this.uploadFileIqama(uid);
        }
        else
        {
          this.constructData(uid);
        }
      }
    );
  }
  uploadFilePB(uid:string):void{
    let file = this.fileList[4].file.item(0);
    console.log("file",file.name);
    var currentUpload = new Upload(file);
    var uploadTask=this.uploadService.uploadFile(currentUpload,uid,file.name);
    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
      (snapshot) =>  {
        // upload in progress
        currentUpload.progress = (uploadTask.snapshot.bytesTransferred / uploadTask.snapshot.totalBytes) * 100;
        this.fileList[4].upload = currentUpload;
      },
      (error) => {
        // upload failed
        console.log(error);
      },
      () => {
        // upload success
        currentUpload.url = uploadTask.snapshot.downloadURL;
        currentUpload.name = currentUpload.file.name;
        this.fileList[4].upload = currentUpload;
        console.log("uploaded "+currentUpload.url);
        if(this.myForm.value.visaCopy != '')
        {
        this.uploadFileVC(uid);
        }
        else if(this.myForm.value.iqama != '')
        {
        this.uploadFileIqama(uid);
        }
        else
        {
          this.constructData(uid);
        }
      }
    );
  }
  uploadFileVC(uid:string):void{
    let file = this.fileList[5].file.item(0);
    console.log("file",file.name);
    var currentUpload = new Upload(file);
    var uploadTask=this.uploadService.uploadFile(currentUpload,uid,file.name);
    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
      (snapshot) =>  {
        // upload in progress
        currentUpload.progress = (uploadTask.snapshot.bytesTransferred / uploadTask.snapshot.totalBytes) * 100;
        this.fileList[5].upload = currentUpload;
      },
      (error) => {
        // upload failed
        console.log(error);
      },
      () => {
        // upload success
        currentUpload.url = uploadTask.snapshot.downloadURL;
        currentUpload.name = currentUpload.file.name;
        this.fileList[5].upload = currentUpload;
        console.log("uploaded "+currentUpload.url);
        if(this.myForm.value.iqama != '')
        {
        this.uploadFileIqama(uid);
        }
        else
        {
          this.constructData(uid);
        }
      }
    );
  }
  uploadFileIqama(uid:string):void{
    let file = this.fileList[6].file.item(0);
    console.log("file",file.name);
    var currentUpload = new Upload(file);
    var uploadTask=this.uploadService.uploadFile(currentUpload,uid,file.name);
    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
      (snapshot) =>  {
        // upload in progress
        currentUpload.progress = (uploadTask.snapshot.bytesTransferred / uploadTask.snapshot.totalBytes) * 100;
        this.fileList[6].upload = currentUpload;
      },
      (error) => {
        // upload failed
        console.log(error);
      },
      () => {
        // upload success
        currentUpload.url = uploadTask.snapshot.downloadURL;
        currentUpload.name = currentUpload.file.name;
        this.fileList[6].upload = currentUpload;
        console.log("uploaded "+currentUpload.url);
        this.constructData(uid);
      }
    );
  }
  private calculateSalary(data)
  {
    /* this.netSalary = data.basic + data.da + data.hra + data.allowance + data.others + data.conveyance + data.medicalAllowance 
    - data.tds - data.pf - data.tax; */
    this.netSalary = data.basic + Number(data.da?data.da:0) + Number(data.hra?data.hra:0) 
    + Number(data.allowance?data.allowance:0) + Number(data.others?data.others:0)
    + Number(data.conveyance?data.conveyance:0) + Number(data.medicalAllowance?data.medicalAllowance:0)
    - Number(data.tds?data.tds:0) - Number(data.pf?data.pf:0) - Number(data.tax?data.tax:0);
    console.log("netSalary",this.netSalary);
    //this.saveUserDetails(data);
  }
  private constructData(uid)
  {
    var date_time = this.dateService.getTimeandDate();
    console.log("documents uploaded",this.fileList);
    var data = this.myForm.value;
    data.photoUrl = this.fileList[0]?this.fileList[0].upload.url:'';
    data.drivingLicenceFront = this.fileList[1]?this.fileList[1].upload.url:'';
    data.drivingLicenceBack = this.fileList[2]?this.fileList[2].upload.url:'';
    data.passportFront = this.fileList[3]?this.fileList[3].upload.url:'';
    data.passportBack = this.fileList[4]?this.fileList[4].upload.url:'';
    data.visaCopy = this.fileList[5]?this.fileList[5].upload.url:'';
    data.iqama = this.fileList[6]?this.fileList[6].upload.url:'';
    if(this.myForm.value.visaIssuedDate != '')
    {
      data.visaIssuedDate = this.dateService.getDate(this.myForm.value.visaIssuedDate);
    }
    if(this.myForm.value.visaExpiryDate != '')
    {
      data.visaExpiryDate = this.dateService.getDate(this.myForm.value.visaExpiryDate);
    }
    if(this.myForm.value.iqamaIssuedDate != '')
    {
      data.iqamaIssuedDate = this.dateService.getDate(this.myForm.value.iqamaIssuedDate);
    }
    if(this.myForm.value.iqamaExpiryDate != '')
    {
      data.iqamaExpiryDate = this.dateService.getDate(this.myForm.value.iqamaExpiryDate);
    }
    if(this.myForm.value.passportExpiryDate != '')
    {
      data.passportExpiryDate = this.dateService.getDate(this.myForm.value.passportExpiryDate);
    }
    data.joiningDate = this.dateService.getDate(this.myForm.value.joiningDate);
    data.dob = this.dateService.getDate(this.myForm.value.dob);
    //data.code = this.getCountryCode();
    data.code = "+966";
    data.uid = uid;
    data.status = "1";
    data.name = this.myForm.value.firstName;
    data.boardingStatus = 'onboard';
    data.createdAt = date_time.date,
    data.createdTime = date_time.time
    data.salary = this.netSalary;
    //this.calculateSalary(data);
    this.saveUserDetails(data)
    console.log("data",data);
  }
  private saveUserDetails(data)
  {
      this.hrmsService.onBoard(data).then(()=>{
        this.submitted = false;
        this.myForm.reset();
        this.netSalary = 0;
        this.imageToUpload = "assets/images/avatar-4.png";
        this.submitButtonDisabled = false;
        this.fileList= [];
        this.sendMessage();
        this.nf.addToast({title:'Onboard Success', msg:'Employee successfully onboard', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});
        this.router.navigateByUrl('/employees');
      });
  }

  private uploadFile(uid:string,i:number):void{
    let file = this.fileList[i].file.item(0);
    //var fileName = this.fileName(i);
    console.log("file",file.name);
    var currentUpload = new Upload(file);
    var uploadTask=this.uploadService.uploadFile(currentUpload,uid,file.name);
    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
      (snapshot) =>  {
        // upload in progress
        currentUpload.progress = (uploadTask.snapshot.bytesTransferred / uploadTask.snapshot.totalBytes) * 100;
        this.fileList[i].upload = currentUpload;
      },
      (error) => {
        // upload failed
        console.log(error);
      },
      () => {
        // upload success
        currentUpload.url = uploadTask.snapshot.downloadURL;
        currentUpload.name = currentUpload.file.name;
        this.fileList[i].upload = currentUpload;
        console.log("uploaded "+currentUpload.url);
      }
    );
  }
  private fileName(i)
  {
    var name;
    switch(i)
    {
      case 1:
      name = 'pp';
      break;
      case 2:
      name = 'dlf';
      break;
      case 3:
      name = 'dlb';
      break;
      case 4:
      name = 'pf';
      break;
      case 5:
      name = 'pb';
      break;
      case 6:
      name = 'vc';
      break;
      case 7:
      name = 'iq';
      break;
    }
    return name;
  }
  openImage(image)
  {
    window.open(
      'https:http://google.com',
      '_blank' // <- This is what makes it open in a new window.
    );
  }
public getAllDesignations()
{
  var x = this.hrmsService.getAllDesignations();
  x.snapshotChanges().subscribe(item=>{
  this.designationsOptions = [];
    item.forEach(element =>{
      if(element.payload.child("name").val() == 'Driver')
      {
        this.driverDesignationKey = element.key;
      }
        this.designationsOptions.push({label: String(element.payload.child("name").val()), value: String(element.key)});
    });
  });
}

public getCountryCode()
{
  var country = this.myForm.value.country;
  switch(country)
  {
    case 'India':
    return "+91";
    case 'China':
    return "+86";
    case 'Saudi Arabia':
    return "+966";
    case 'United States':
    return "+1";
  }
}

maxLength: number =9;
  onChangeCountry(e)
  {
    this.phone_error = false;
    //switch(e.target.value)
    switch(e)
    {
      case "+91" : this.maxLength  = 10;
      //console.log("e.target.value",e.target.value);
      //this.myForm.controls["phoneNumber"].setValidators([Validators.minLength(10),Validators.maxLength(10)]);
      //this.myForm.controls["phoneNumber"].setErrors({maxlength:10});
      break;
      case "+966" : this.maxLength  = 9;
      //console.log("e.target.value",e.target.value);
      //this.myForm.controls["phoneNumber"].setValidators([Validators.minLength(9),Validators.maxLength(9)]);
      break;
    }
  }
  public keyPress(event: any) {
    this.phone_error = false;
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
    else
    {
      var phone = this.myForm.value.phoneNumber;
      if(phone.length >= this.maxLength)
      {
        event.preventDefault();
      }
    }
  }
  preventPaste(e)
  {
    e.preventDefault();
    return false;
  }
  get Currency()
  {
    var currency;
    this.hrmsService.getCurrency().on("value",(generalSetting)=>{
         currency =  generalSetting.child('currency').val();
      });
    return currency;
}

getReportingTo()
{
  this.userService.getAllUser().snapshotChanges().subscribe((data)=>{
    this.reportingToOptions = [];
    data.forEach(user=>{
      if(user.payload.child("role").val() == 'super admin' || user.payload.child("role").val() == 'admin' || user.payload.child("role").val() == 'manager')
      {
        console.log("user",user.payload.toJSON());
        this.reportingToOptions.push({label: user.payload.child("name").val(), value: user.key});
      }
    });
  });
  
}
getCompanyAssets()
{
  this.hrmsService.getAllAssets().snapshotChanges().subscribe((data)=>{
    this.companyassets = [];
    data.forEach(assest=>{
        this.companyassets.push({label: assest.payload.child("name").val(), value: assest.key});
    });
  });
}
keyPressCalculateSalary()
{
  this.calculateSalary(this.myForm.value);
}
sendMessage() {
  this.messageEvent.emit("tab1");
}
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/hrms/employee/onboard/onboard.component.ts